export const assignHelper = (attribute) => (state, value) => {
  state[attribute] = value;
};
